import type { Data } from "@eai-toolkit/client";
import {
  type BaseQueryState,
  dehydrateQueryStateBase,
  dehydrateQueryStateToStringBase,
  hydrateQueryStateBase,
  hydrateQueryStateFromStringBase,
} from "@store/utils/queryStateUtils";
import type { Location } from "history";

import { DEFAULT_PAGE_LIMIT } from "@helpers/constants";

import {
  fields,
  getDefaultSortOrder,
} from "../../modules/data-explorer/data/fields";

export type DataQueryState = BaseQueryState<Data>;

export const defaultSortField = fields.created;

const QUERY_DEFAULTS = {
  defaultSort: {
    fieldName: defaultSortField.fieldName,
    direction: getDefaultSortOrder(defaultSortField),
  },
  defaultLimit: DEFAULT_PAGE_LIMIT,
} as const;

// Data-specific wrapper - delegates to generic base with Data config
export function hydrateDataQueryState(location: Location): DataQueryState {
  return hydrateQueryStateBase<Data>(location, QUERY_DEFAULTS);
}

// Data-specific wrapper - delegates to generic base
export function dehydrateDataQueryState(opts: {
  queryState: DataQueryState;
  location: Location;
}): URLSearchParams {
  return dehydrateQueryStateBase<Data>(opts);
}

/**
 * Hydrates a serialized search string into a DataQueryState object.
 */
export function hydrateDataQueryStateFromString(
  searchString: string,
): DataQueryState {
  return hydrateQueryStateFromStringBase<Data>(searchString, QUERY_DEFAULTS);
}

/**
 * Dehydrates a DataQueryState object to a serialized search string.
 */
export function dehydrateDataQueryStateToString(
  queryState: DataQueryState,
): string {
  return dehydrateQueryStateToStringBase<Data>(queryState);
}
